import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {connect} from 'react-redux';
import axios from 'axios';
function Special_service_settings_popup(props){

  function onSubmit(params){
    console.log(params, 'PARAAAAMS');
    axios.post('/api/special_services/updateSettings', {...params, workspace_default_special_service_id:props.special_service.service.id}).then(()=>{
      window.location.href=window.location.href;
    })
  }
  let initial_values=props.special_service.instance
  return(
    <Form
      initialValues={initial_values}
      onSubmit={onSubmit}
      {...props}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} handleClose={props.handleClose} always_open title={props.special_service.service.name+' credit settings'} content={
          <div style={{width:'95vw', maxWidth:'600px'}}>
            <div style={{marginTop:'20px', marginBottom:'20px', display:'flex', justifyContent:'center', alignItems:'center'}}><Explanation_text text={'special_service_settings_popup'}/></div>
            <div style={{width:'calc(100% - 40px)', marginLeft:'20px'}}><Text  type='number' max={props.special_service.service.max_credits_monthly_conversion} min={0} color='transparent' title={'Auto exchange credits per person (max: '+props.special_service.service.max_credits_monthly_conversion+', conversion:'+props.special_service.service.credits_conversion_rate+')'} name='extra_monthly_credits'/></div>
            <div style={{height:'30px'}}/>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}

export default connect(ss, dd)(Special_service_settings_popup)


function ss(state){
  return{
    workspace:(state.workspaces.data==undefined)?undefined:state.workspaces.data[state.workspaces.current_workspace_id],
    refresh:state.workspaces.data[state.workspaces.current_workspace_id].refresh
  }
}

function dd(dispatch){
  return{
    updateSpecialServiceSettings:(params)=>{dispatch({type:'REQUEST_UPDATE_WORKSPACE_SPECIAL_SERVICE_SETTINGS', payload:params});}
  }
}
